// PrivateRoute.js

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import LoadingSpinner from './assets/LoadingSpinner';

const PrivateRoute = ({ element: Element, ...rest }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner/>;
  }

  // 1. Verificar autenticación. Si no está logueado, redirige a /acceso-miembros.
  if (!user) {
    return <Navigate to="/acceso-miembros" replace />;
  }

  // 2. Lógica de restricción de /cupo-asignado.
  // Solo entra quien está 'Activo' — cubre 'Espera', 'Registrado' y
  // cualquier estado futuro con el mismo criterio: si no tenés cupo
  // asignado, no hay nada para vos en esta ruta.
  if (location.pathname === '/cupo-asignado') {
    const estadoLista = user.profileData?.estadoLista;

    if (estadoLista !== 'Activo') {
      // Se redirige al usuario a su perfil o a otra página.
      // Se añade un parámetro de estado para mostrar un mensaje en la página de destino.
      return <Navigate to="/perfil" state={{ from: location.pathname, blocked: true }} replace />;
    }
  }

  // Si el usuario está logueado y no hay restricciones, permite el acceso al Elemento.
  return Element;
};

export default PrivateRoute;
// El resto del código que tenías en este archivo (PerfilMiembro, RutaSecreta) no es relevante para el cambio.